<template>
  <div class="view-container">
    <div class="text-h4 font-weight-medium text-title">
      Skills
    </div>
    <div class="card-container">
      <CardSkill
        class="card-size"
        img="assets/icons/desktop.svg"
        title="Web development"
        description="Node.js, Laravel 5, PHP, JS, Vue.js, API Rest, GraphQL, ORMs, SQL"
      ></CardSkill>
      <CardSkill
        class="card-size"
        img="assets/icons/mobile.svg"
        title="Mobile app development"
        description="Kotlin, Android"
      ></CardSkill>
      <CardSkill
        class="card-size"
        img="assets/icons/hybrid.svg"
        title="Hybrid mobile app developer"
        description="Ionic, PWA Vue.js"
      ></CardSkill>
      <CardSkill
        class="card-size"
        img="assets/icons/api.svg"
        title="GraphQL and API interface developer"
        description="GraphQL, JSON, PHP, Laravel, Node.js"
      ></CardSkill>
    </div>
    <!-- <div>
          Iconos diseñados por
          <a href="https://www.freepik.com" title="Freepik">Freepik</a> from
          <a href="https://www.flaticon.es/" title="Flaticon">
            www.flaticon.es
          </a>
        </div> -->
  </div>
</template>

<script>
import CardSkill from '@/components/perfil/cardSkill'

export default {
  components: {
    CardSkill
  },
  props: {
    // project: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
// * {
//    color: white;
// }

.view-container {
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.card-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

.card-size {
  width: 380px;
}

@media (max-width: 1010px) and (min-width: 600px) {
  .text-title {
    text-align: center;
  }
}

@media (max-width: 600px) {
  .text-title {
    text-align: center;
  }
}
</style>
